module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_login", [["div",{"class":"login-form-wrapper pad-tb pad-lr"},[["div",{"class":"loginform_container"}],["div",{"class":"forgotform_container","style":"display: none;"}]]],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/login.tpl
// module id = 1220
// module chunks = 4